import * as React from 'react';

import { inject, observer } from 'mobx-react';

import { catalogConfig, getConfig } from '@constants';

import { EAppsCounters, EAppsGenreEng, EContext, ERefsApps, EStore, EResponseStatus } from '@enums';

import { objectHasKey } from '@utils';

import { commonWillUnmount, fetchData } from '@decorators';

import { IAppState } from '@stores';

import { CompilationPage } from '@components';

import { ICGIUrlOptions } from '@interfaces/utils';

import { ICatalogGenreProps, IMatchParams, ICatalogGenreState } from './types';

const genres: { genre: EAppsGenreEng; paginatorCounter: EAppsCounters }[] = [
	{
		genre: EAppsGenreEng.ROLEPLAY,
		paginatorCounter: EAppsCounters.PAGINATOR_ROLEPLAY,
	},
	{
		genre: EAppsGenreEng.LUCKY,
		paginatorCounter: EAppsCounters.PAGINATOR_LUCKY,
	},
	{
		genre: EAppsGenreEng.STRATEGY,
		paginatorCounter: EAppsCounters.PAGINATOR_STRATEGY,
	},
	{
		genre: EAppsGenreEng.CASUAL,
		paginatorCounter: EAppsCounters.PAGINATOR_CASUAL,
	},
	{
		genre: EAppsGenreEng.LOGIC,
		paginatorCounter: EAppsCounters.PAGINATOR_LOGIC,
	},
	{
		genre: EAppsGenreEng.ROWS,
		paginatorCounter: EAppsCounters.PAGINATOR_ROWS,
	},
	{
		genre: EAppsGenreEng.EXTERNAL,
		paginatorCounter: EAppsCounters.PAGINATOR_EXTERNAL,
	},
];

@inject(
	EStore.APPS_BY_GENRE,
	EStore.UI,
	EStore.CURRENT_USER,
	EStore.MAIN_MENU_APPS,
	EStore.COUNTERS,
)
@observer
@commonWillUnmount()
@fetchData([
	async (
		{ appsByGenreStore: store, currentUserStore: { currentUser: user } }: IAppState,
		{ page: pageParam, genre: genreParam }: IMatchParams,
	) => {
		// на сервере (только на сервере) - жанр ставится как "genre/page"
		const serverParams = genreParam.split('/');
		const genre = (IS_SSR ? serverParams[0] : genreParam) as EAppsGenreEng;
		const page = IS_SSR ? serverParams[1] : pageParam;
		const appsByGenreCompilation = store?.appsByGenreCompilation;

		if (genre && (!appsByGenreCompilation || appsByGenreCompilation[genre]?.status !== EResponseStatus.OK)) {
			const isMyCreated = user?.isMyCreated;
			const limit = !!isMyCreated
				? catalogConfig.appsLimit.auth
				: catalogConfig.appsLimit.guest;
			const offset = !!isMyCreated
				? 0 // для авторизованного юзера показываем без сдвига
				: limit * (Number(page) - 1);

			await store.fetch(
				genre,
				{
					context: EContext.MOBILE,
					limit,
					offset,
					user,
				});
		}
	},

	// UI STATE
	({ uiStore }: IAppState) => {
		if (uiStore.status !== EResponseStatus.OK) {
			uiStore.setTopMenuInitialState({ isShowIcons: true });
		}
	},

])
export class CatalogGenre extends React.PureComponent<ICatalogGenreProps, ICatalogGenreState> {

	fetchApps = async (options: ICGIUrlOptions) => {
		if (!this.props.currentUserStore.currentUser.isMyCreated) {
			this.props.appsByGenreStore.clearGenre(options.genre);
		}

		return await this.props.appsByGenreStore.fetch(
			this.props.match?.params.genre as EAppsGenreEng,
			options,
		);
	};

	fetchAppsNext = async (options: ICGIUrlOptions) => {
		return await this.props.appsByGenreStore.fetchNext(
			this.props.match?.params.genre as EAppsGenreEng,
			options,
		);
	};

	render() {
		const {
			match: { params: { genre = '' } = {} },
			appsByGenreStore = null,
		} = this.props;
		const MAP_PAGE_GENRE_TO_REF: { [key: string]: string } = {};
		const appsByGenre = appsByGenreStore?.getByGenre(genre as EAppsGenreEng);
		const paginatorCounter = genres
			.filter(({ genre: genreName }) => genreName === genre)?.[0]?.paginatorCounter || 0;
		const compilationDescription = getConfig().apps?.compilationDescription?.genres;
		/* eslint-disable @typescript-eslint/ban-ts-ignore */
		// @ts-ignore
		const compilationDescriptionByGenre = compilationDescription ? compilationDescription[genre] : null;

		Object.keys(EAppsGenreEng).forEach((app: string) => {
			const refKey = `PAGE_${app}`;
			if (objectHasKey(EAppsGenreEng, app) && objectHasKey(ERefsApps, refKey)) {
				MAP_PAGE_GENRE_TO_REF[EAppsGenreEng[app]] = ERefsApps[refKey];
			}
		});

		const appsListOptions = {
			apps: appsByGenre?.data || [],
			responseStatus: appsByGenre?.status,
			urlRef: MAP_PAGE_GENRE_TO_REF[genre] as ERefsApps,
			hasDescription: true,
			hasRating: true,
			hasInstalls: true,
		};

		return (
			<CompilationPage
				appsListOptions={appsListOptions}
				fetchApps={this.fetchApps}
				fetchAppsNext={this.fetchAppsNext}
				compilationDescription={compilationDescriptionByGenre}
				total={appsByGenre?.total}
				hasMore={appsByGenre?.hasMore}
				// счётчик кликов на пагинацию
				paginationCounter={paginatorCounter}
			/>
		);
	}

}
